import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import AboutFour from '../Components/About/AboutFour'
import OfferTwo from '../Components/Offer/OfferTwo'
import ElementSection from '../Components/Elements/ElementSection'
import TourGuideTwo from '../Components/Guide/TourGuideTwo'
import TestimonialThree from '../Components/Testimonials/TestimonialThree'
import BrandOne from '../Components/Brand/BrandOne'
import GalleryFive from '../Components/Gallery/GalleryFive'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import WhatsAppButton from '../Components/WA button/WAbutton';

import FooterOne from '../Components/Footer/FooterOne'

function About() {
    return (
        <>
            <HeaderOne />
            <Breadcrumb
                title="About us"
            />
            <AboutFour />
            <OfferTwo />
            <ElementSection />
            {/* <TourGuideTwo /> */}
            <TestimonialThree />
            {/* <BrandOne/> */}
            {/* <GalleryFive /> */}
            <FooterFour />
            <WhatsAppButton phone="971561678861" />

            <ScrollToTop />
        </>
    )
}

export default About
